import { render, staticRenderFns } from "./SponsorJobOffersListComponent.vue?vue&type=template&id=73c25316&"
import script from "./SponsorJobOffersListComponent.vue?vue&type=script&lang=js&"
export * from "./SponsorJobOffersListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports